import React, { useState } from 'react';
import Text from '../../atoms/Text/Text';
import Image from '../../atoms/Image/Img';
import EntitiesTableStyle from './EntitiesTableStyle';
import nike from '../../../assets/images/nike.svg';
import elipses from '../../../assets/images/elipses.svg';
import Pagination from '../Pagination/Pagination';
import dayjs from 'dayjs';
import {exportData} from '../../../redux/actions/ExportAction';
import { useNavigate } from "react-router-dom";
import EntitiesDetails from '../EntitiesDetails/EntitiesDetails';
import { alertActions } from '../../../redux/actions/AlertActions';
import {appInstance as axios} from '../../../axios';
import {useDispatch, useSelector} from 'react-redux';
import { TypedDispatch, RootStore } from '../../../config/ConfigStore';
import Cookies from 'js-cookie';
import FetchLoading from '../../molecules/FetchLoading/FetchLoading';

type EntitiesTableProps = {
  data: any,
  pagination: number,
  setPagination: Function,
  changePage: Function,
  page: number,
  reloadPage: Function
}

const EntitiesTable = ({data, pagination, setPagination, changePage, page, reloadPage}: EntitiesTableProps) => {
  const dispatch: TypedDispatch = useDispatch();
  const state:any = useSelector( (state:RootStore) => state);
  let timeOutId:any = null;
  const [selectedMenu, setSelectedMenu] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(false);
  const [selectedId, setSelectedId] = useState("");
  const [entitiesData, setEntitiesData] = useState({})
  // const navigate = useNavigate();

  const onClickHandler = (value: boolean, id: string) => {
    if(selectedMenu !== false){
      setSelectedMenu(false);
      return;
    }
    setSelectedMenu(value);
    setSelectedId(id)
  }

  const onBlurHandler = () => {
      timeOutId = setTimeout(() => {
        setSelectedMenu(false);
      });
  }

  const onFocusHandler = () =>{
      clearTimeout(timeOutId);
  }

  const renderFetchLoading = () => {
    if(fetchLoading){
      return(
        <FetchLoading />
      )
    }
  }

  const handleAllCheck = async (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.checked) {
      await dispatch(exportData(state.dashboardReducer.results.data.content))
      console.log(state.exportReducer);
    }
    else{
      await dispatch(exportData([]));
      console.log(state.exportReducer);
    }
  };

  const handleCheckItem = (item: Record<any, any>) => {
    if(state.exportReducer.results.data.includes(item)){
      const newArr = state.exportReducer.results.data.filter( (record: Record<any,any>) => record.id !== item.id)
      console.log(newArr);
      return dispatch(exportData(newArr));
    }
    const update = [...state.exportReducer.results.data, item]
    console.log(update);
    return dispatch(exportData(update));
  };

  const fetchEntitiesData = async (id: string) => {
    try{
      setFetchLoading(true);
      const res = await axios.get(`/entities?id=${id}${state.authReducer.results.user_level === 2 ? `&isGlobal = 1` : ''}`, {
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Cookies.get("userToken")}`
        }
      });
      setEntitiesData(res.data.data.content[0]);
      setFetchLoading(false);
    }catch (error: any) {
      setFetchLoading(false);
      if (error.message === "Network Error") {
        dispatch(alertActions.error('Network Error, try again!!!'));
      } else {
        dispatch(alertActions.error(error.response.data.error));
      }
    }
  }

  const setData = (value: object) => {
    setEntitiesData(value)
  }

  return (
    <>
      {renderFetchLoading()}
      <EntitiesTableStyle>
        <div className={`container-full`}>
          <div className={`div-md-9 table__box`}>
            <table>
              <thead>
                <tr className={`table-header`}>
                  <th>
                    <input type="checkbox" onChange={handleAllCheck}/>
                    <Image image={nike} />
                  </th>
                  <th>
                    <Text value="Entities" className={`table-title`} />
                  </th>
                  <th>
                    <Text value="Date Modified" className={`table-title`} />
                  </th>
                  <th>
                    <Text value="Approval Status" className={`table-title`} />
                  </th>
                </tr>
              </thead>
              <tbody className={`table-body`}>
                {
                  (data.data.content !== undefined && data.data.content.length > 0) ?
                  data.data.content.map((entity: Record<any, any>, key: string) => {
                    return (
                      <tr className={`table-row`} key={key} onClick={() => fetchEntitiesData(entity.id)}>
                        <td>
                          <input
                            type="checkbox"
                            checked={state.exportReducer.results.data.includes(
                              entity
                            )}
                            onChange={() => handleCheckItem(entity)}
                          />
                          <Image image={nike} />
                        </td >
                        <td> 
                          <Text value={entity.name} className='label'/>
                        </td>
                        <td> 
                          <Text value={dayjs(entity.lastModifiedDate).format('MM/DD/YYYY')} className='label' />
                          <Text value={dayjs(entity.lastModifiedDate).format('h:mm A')} className='date' />
                        </td>
                        <td>
                          {
                            (entity.status === 0) ? 
                            <button className='status --inactive'>
                              Inactive
                            </button> : null
                          }
                          {
                            (entity.status === 1) ? 
                            <button className='status --active'>
                              Active
                            </button>: null
                          }
                          {
                            (entity.status > 1) ? 
                            <button className='status --pending'>
                              Pending
                            </button> : null
                          } 
                        </td>
                      </tr>
                    )
                  }) : null
                }
              </tbody>
            </table>
          </div>
          <div className={`div-md-3 table__content`}>
            <EntitiesDetails data={entitiesData} reloadPage={reloadPage} setData={setData}/>        
          </div>
        </div>
        <div className={`container-full pagination`}>
          <Pagination pagination={pagination} changePage={changePage} setPagination={setPagination} page={page}/> 
        </div>
      </EntitiesTableStyle>
    </>
  );
};

export default EntitiesTable;
